import { schemas } from '@convergence/client';
import { fetch } from '../fetch';
import { useMutation } from '@tanstack/react-query';

export function deleteAnalysis(slug: string) {
  return fetch(`/analysis/${slug}`, { method: 'DELETE' }, schemas.SuccessDto);
}

export function useDeleteAnalysisMutation() {
  return useMutation({
    mutationFn: deleteAnalysis,
    mutationKey: ['delete-analysis']
  });
}
